import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb } from 'semantic-ui-react'
import { FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import { ConfigContainer, ConfigMenuContainer, ConfigMenuButton } from './styled'
import { AdminContainer } from '../styled'
import { rootPath, adminPath, vendorUserManagementPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'

const Configuration = (props) => {
  const { user, history } = props

  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const MenuButton = (data) => {
    const { title, icon, path } = data
    return (
      <ConfigMenuButton onClick={() => {
        if (path) {
          history.push(path)
        }
      }}>
        <Icon size='3x' icon={icon} />
        <div className='title'>{title}</div>
      </ConfigMenuButton>
    )
  }

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Configuration</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
              { key: 'Config', content: 'Configuration', active: true }
            ]
          }
        />
      </div>
      <ConfigContainer>
        <ConfigMenuContainer>
          <MenuButton title='User Management' icon='users-cog' path={vendorUserManagementPath} />
        </ConfigMenuContainer>
      </ConfigContainer>
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
  })
}

const mapDispatchToProps = {
  toggleSideMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(Configuration)